import { RegisterCard } from "../../components/RegisterCard";
import { TimeSelect } from "../../components/TimeSelect";
import { CircleLoader } from "../../components/CircleLoader";
import { Thermometer, Clock, Plus } from "lucide-react";

export const CAtemeperature = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in slide-in-from-bottom-4">
      <RegisterCard
        title="Temperature Check"
        details="Record periodic thermal readings."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-8 order-2 lg:order-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Condition Toggle */}
            <div className="space-y-3">
              <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                Condition
              </label>
              <div className="flex bg-slate-100 p-1 rounded-2xl">
                {["Low", "Normal", "High"].map((lvl) => (
                  <button
                    key={lvl}
                    type="button"
                    onClick={() => onFormChange("condition", lvl)}
                    className={`flex-1 py-2 rounded-xl font-bold text-xs transition-all
                      ${formData["condition"] === lvl ? "bg-white text-blue-600 shadow-sm" : "text-slate-400 hover:text-slate-600"}`}
                  >
                    {lvl}
                  </button>
                ))}
              </div>
            </div>

            {/* Time Select */}
            <div className="space-y-3">
              <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1 flex items-center gap-1">
                <Clock size={14} /> Time Recorded
              </label>
              <div className="h-[46px] border-2 border-slate-100 rounded-2xl bg-slate-50 px-2 flex items-center">
                <TimeSelect
                  value={formData.time ?? "10:00"}
                  onChange={(val: string) => onFormChange("stop_time", val)}
                />
              </div>
            </div>
          </div>

          {/* Temperature Numeric Input */}
          <div className="space-y-3">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Degrees (°C)
            </label>
            <div className="relative">
              <input
                required
                type="text"
                placeholder="e.g. 36.5"
                value={formData["temperature"]}
                onChange={(e) => onFormChange("temperature", e.target.value)}
                className="w-full h-14 pl-12 pr-5 bg-slate-50 border-2 border-slate-100 rounded-2xl text-xl font-bold text-slate-700 focus:bg-white focus:border-blue-500 outline-none transition-all"
              />
              <Thermometer
                size={20}
                className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-black uppercase tracking-widest transition-all"
          >
            {loading ? <CircleLoader /> : "Save Temperature"}
          </button>
        </div>

        <div className="lg:w-64 bg-blue-50 flex items-center justify-center p-8 order-1 lg:order-2">
          <img
            src="/img/thermometer.svg"
            className="w-40 h-40 animate-pulse"
            alt="thermometer"
          />
        </div>
      </form>
    </div>
  );
};
